// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconWaterblastDealer: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16">
            <path
                fill="#af5d1b"
                d="M9.34863299,12.125 L3.72363299,12.125 L3.72363299,7.4375 L1.87441438,7.4375 L1.87412158,14.9375 C1.87412158,15.4575195 2.29160205,15.875 2.81162158,15.875 L10.3116216,15.875 C10.8316411,15.875 11.2491216,15.4575195 11.2491216,14.9375 L11.249456,7.4375 L9.34863344,7.4375 L9.34863344,12.125 L9.34863299,12.125 Z M18.5917966,5.04101598 L16.0904293,1.29101598 C15.914648,1.02734411 15.6216793,0.873535514 15.3102534,0.873535514 L3.43652353,0.873535514 C3.1250976,0.873535514 2.83212885,1.02734411 2.6563476,1.29101598 L0.158789009,5.04101598 C-0.257226974,5.66503906 0.18955037,6.5 0.940429419,6.5 L17.8125004,6.5 C18.5595708,6.5 19.0048836,5.66503906 18.5917966,5.04101598 Z M14.9736334,15.40625 C14.9736334,15.6625977 15.1860349,15.875 15.4423825,15.875 L16.3801758,15.875 C16.6365235,15.875 16.8489258,15.6625977 16.8489258,15.40625 L16.8486325,7.4375 L14.9733393,7.4375 L14.9736334,15.40625 Z"
            />
        </svg>
    );
};

export default React.memo(IconWaterblastDealer);
